import { c as _c } from "react/compiler-runtime";
import { IcoArrowTopRight16 } from '@onefootprint/icons';
import type { OrgValidateResponse } from '@onefootprint/request-types/dashboard';
import { LinkButton } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { Trans, useTranslation } from 'react-i18next';
import getBadgeVariantByStatus from '@/utils/get-badge-variant-by-status';
type ValidatedOnboardingProps = {
  data?: OrgValidateResponse;
};
export const ValidatedOnboarding = t0 => {
  const $ = _c(53);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "testMode"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "entityStatuses"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    t: tStatus
  } = useTranslation("common", t2);
  if (!data) {
    return null;
  }
  let t3;
  if ($[2] !== data.requiresManualReview || $[3] !== data.status) {
    t3 = getBadgeVariantByStatus(data.status, data.requiresManualReview);
    $[2] = data.requiresManualReview;
    $[3] = data.status;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const badgeVariant = t3;
  let T0;
  let isBusiness;
  let t10;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[5] !== badgeVariant || $[6] !== data.entityKind || $[7] !== t) {
    const statusTextColor = {
      success: "text-success",
      error: "text-error",
      warning: "text-warning",
      neutral: "text-neutral"
    };
    isBusiness = data.entityKind === "business";
    t10 = "flex flex-col gap-6";
    t8 = "flex flex-col gap-1";
    let t11;
    if ($[17] !== t) {
      t11 = t(_temp);
      $[17] = t;
      $[18] = t11;
    } else {
      t11 = $[18];
    }
    if ($[19] !== t11) {
      t9 = <h3 className="text-label-2 text-primary">{t11}</h3>;
      $[19] = t11;
      $[20] = t9;
    } else {
      t9 = $[20];
    }
    t7 = "text-body-2 text-secondary";
    T0 = Trans;
    t5 = "playbook-builder";
    if ($[21] !== isBusiness) {
      t6 = $_0 => isBusiness ? $_0.testMode.results.businessDescription : $_0.testMode.results.description;
      $[21] = isBusiness;
      $[22] = t6;
    } else {
      t6 = $[22];
    }
    t4 = cx(["text-body-2", statusTextColor[badgeVariant]]);
    $[5] = badgeVariant;
    $[6] = data.entityKind;
    $[7] = t;
    $[8] = T0;
    $[9] = isBusiness;
    $[10] = t10;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    T0 = $[8];
    isBusiness = $[9];
    t10 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
    t7 = $[14];
    t8 = $[15];
    t9 = $[16];
  }
  let t11;
  if ($[23] !== data.status) {
    t11 = $_1 => $_1[data.status];
    $[23] = data.status;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== tStatus) {
    t12 = tStatus(t11);
    $[25] = t11;
    $[26] = tStatus;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t12 || $[29] !== t4) {
    t13 = {
      status: <span className={t4}>{t12}</span>
    };
    $[28] = t12;
    $[29] = t4;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== T0 || $[32] !== t13 || $[33] !== t5 || $[34] !== t6) {
    t14 = <T0 ns={t5} i18nKey={t6} components={t13} />;
    $[31] = T0;
    $[32] = t13;
    $[33] = t5;
    $[34] = t6;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== t14 || $[37] !== t7) {
    t15 = <p className={t7}>{t14}</p>;
    $[36] = t14;
    $[37] = t7;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== t15 || $[40] !== t8 || $[41] !== t9) {
    t16 = <div className={t8}>{t9}{t15}</div>;
    $[39] = t15;
    $[40] = t8;
    $[41] = t9;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  const t17 = `/${isBusiness ? "businesses" : "users"}/${data.fpId}/onboardings/${data.onboardingId}/trace`;
  let t18;
  if ($[43] !== isBusiness || $[44] !== t) {
    t18 = isBusiness ? t(_temp2) : t(_temp3);
    $[43] = isBusiness;
    $[44] = t;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== t17 || $[47] !== t18) {
    t19 = <LinkButton href={t17} target="_blank" iconComponent={IcoArrowTopRight16}>{t18}</LinkButton>;
    $[46] = t17;
    $[47] = t18;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== t10 || $[50] !== t16 || $[51] !== t19) {
    t20 = <div className={t10}>{t16}{t19}</div>;
    $[49] = t10;
    $[50] = t16;
    $[51] = t19;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  return t20;
};
function _temp($) {
  return $.results.title;
}
function _temp2($_2) {
  return $_2.results.viewBusiness;
}
function _temp3($_3) {
  return $_3.results.viewUser;
}